<template>
    <div ref="container" class="container d-flex flex-column h-100">
            <div>
                <header class="text-center pt-4" style="z-index: 100;">
                    <!-- If user is logged in - hide the welcome text -->
                    <h1 >{{$t('translations.welcome_to')}} {{ this.tBrand('app_name') }}
                        <br><span class="small" v-if="this.$root.provider.name">{{$t('translations.at')}} {{ this.$root.provider.name }}</span>
                    </h1>
                    <div v-if='showServiceMessage' class="m-3 mt-2 p-3 card border-0 shadow-sm"><p style="white-space: break-spaces;">{{$root.provider.service_message}}</p></div>
                </header>

                <div class='card-default'>                        
                    <router-link :to='$root.isLoggedIn() ? {name: "accessType"} : {name: "loginType"}' tag="button" class="card-button w-100 mb-2">
                        <div class="card-icon"><img src="/img/egl/icon-placeholder.svg" alt="link icon"></div>
                        <div><h2>{{ $t('translations.login_to_consult_your_GP')}}</h2></div>
                    </router-link>
                </div>

                <footer class="container">
                    <!-- REpeat prescriptions <router-link :to="{ name: 'prescriptions', params: {} }" class="btn btn-round">Repeat prescriptions</router-link> -->
                    <a v-if='tBrandSetting("conf_emergency_banner")' href="https://www.nhs.uk/using-the-nhs/nhs-services/urgent-and-emergency-care/when-to-call-999/" class="alert alert-danger text-center d-block">{{ $t('translations.do_not_use_in_emergencies')}}</a>
                    <a v-if='tBrandSetting("conf_covid_19_banner")' href="https://www.nhs.uk/conditions/coronavirus-covid-19/" class="alert alert-covid text-center">{{ $t('translations.nhs_covid')}}</a>
                    <router-link v-if='tBrandSetting("conf_our_service_times") && $root.provider && $root.provider.id' :to="{name: 'serviceTimes'}" class="btn btn-round btn-outline-primary btn-block">{{ tBrandKey('our_service_times') }}</router-link>
                    <router-link v-if='tBrandSetting("conf_when_is_your_clinician_working") && $root.lookup && $root.lookup.staff && $root.lookup.staff.length' :to="{name: 'staffAvailability'}" class="btn btn-round btn-outline-primary btn-block">{{ $t('translations.when_is_your_GP_working')}}</router-link>
                </footer>


            </div>
            <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
                <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
            </div>
            <div v-else class="pb-5"></div>

    </div><!--ref:container-->


</template>

<script>
var moment = require('moment');
export default {
    props: [
    ],
    data: function(){
        return {
            scrollTo: null,
        }
    },
    mounted() {
        if(this.$root.isLoggedIn()) {
            this.$router.replace({name: "Profile"});
        }
    },
    computed: {
        charactersLeft() {
            var char = this.$root.selfHelpSearch.length;
            var limit = 50;

            if(char > limit) {
                this.$root.selfHelpSearch = this.$root.selfHelpSearch.substr(0, limit);
                char = this.$root.selfHelpSearch.length;
            }
            return (limit - char) + " " + this.$t('translations.characters_left') + ".";
        },
        showServiceMessage() {
            return this.$root.showServiceMessage;
        },
        showPrescriptionLink() {
        //    return this.$root.showPrescriptionLink;
        },
    },
    methods: {
        scrollToView(event) {
            setTimeout(function() {event.target.scrollIntoView(true);}, 500);
        },
        
    }
}
</script>
